import Vue from 'vue'
import colors from 'vuetify/es5/util/colors'
import $utils from '@/utils/utils'

let availableLanguages = [
    { value: 'en-US', text: 'English' },
    { value: 'vi-VN', text: 'Việt Nam' }
]
let mapLanguageValueToName = {}
availableLanguages.forEach(item => {
    mapLanguageValueToName[item.value] = item.text
})

const roles = {
    USER: 'user_group',
    ADMIN: 'admin_group',
    SALE: 'sale_group',
    MARKETING: 'marketing_group'
}

const env = {
    DEV: 'development',
    STA: 'staging',
    PRO: 'production'
}

const projectType = {
    POSTPAID: 'postpaid',
    PREPAID: 'prepaid'
}

const AuthenticationService = {
    SELF: 'SELF',
    FPT_ID: 'FPT_ID'
}

const channelList = [
    { text: 'Live chat', value: 'livechat' },
    { text: 'Facebook at work', value: 'fbatwork' },
    { text: 'Facebook messenger', value: 'facebook' },
    { text: 'Viber', value: 'viber' },
    { text: 'Zalo', value: 'zalo' },
    { text: 'Api', value: 'api' }
]

const rateColors1to5 = [
    colors.yellow.lighten5,
    colors.yellow.lighten4,
    colors.yellow.lighten3,
    colors.yellow.lighten2,
    colors.yellow.lighten1
]

const $const = {
    roles: roles,
    env: env,
    projectType: projectType,
    LIMIT_USAGE: 'Limit',
    NO_LIMIT_USAGE: 'Unlimit',
    COMPLETED: 'completed',
    ACTIVE: 'active',
    WAITING: 'waiting',
    DRAFT: 'draft',
    CANCELED: 'canceled',
    TOKEN_KEY: 'jwToken',
    MAX_PROJECTS: 3,
    DATE_FORMAT: 'YYYY-MM-DD',
    MONTH_FORMAT: 'YYYY-MM',
    LANGUAGE: 'language',
    authenticationService: AuthenticationService,
    currentProjectIdKey: 'currentProject',
    channelList: channelList,
    // rateColors1to5: rateColors1to5,
    rateColors1to5: [
        'darkred',
        'orange',
        'yellow',
        'green',
        'blue'
    ],
    reactionColors: [
        'green',
        'darkred'
    ],
    i18n: {
        availableLanguages,
        mapLanguageValueToName
    }
}

Vue.prototype.$const = $const

export default $const
